<template>
  <v-card>
    <v-card-title>
      {{ $t('billing-details') }}
    </v-card-title>
    <v-card-text>
      <div v-if="$account.current.customer">
        <strong>{{ $t('informations-name') }}</strong> : {{ $account.current.customer.informations.name }}<br/>
        <strong>{{ $t('informations-email') }}</strong> : {{ $account.current.customer.informations.email }}<br/>
        <strong>{{ $t('informations-address') }}</strong> : <br/>
        <div class="pl-4">{{ $account.current.customer.informations.address.line1 }}</div>
        <div class="pl-4">
          {{ $account.current.customer.informations.address.postal_code }}
          {{ $account.current.customer.informations.address.city }}
          {{ $account.current.customer.informations.address.country }}
        </div>
      </div>
      <div v-else>
        {{ $t('billing-details-empty') }}
      </div>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="$ui.openDialog('edit_customer_informations')" color="primary" text>{{ $t('actions.edit') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'ABillingCustomerWidget'
}
</script>

<style scoped>

</style>

<i18n>
{
	"en": {
		"billing-details": "Billing information",
		"billing-details-empty": "No billing details.",
		"informations-address": "Address",
		"informations-email": "Billing email",
		"informations-name": "Name or Company"
	},
	"es": {
		"billing-details": "Información de facturación",
		"billing-details-empty": "Sin detalles de facturación.",
		"informations-address": "Dirección",
		"informations-email": "Correo electrónico de facturación",
		"informations-name": "Nombre o Empresa"
	},
	"fr": {
		"billing-details": "Coordonnées de facturation",
		"billing-details-empty": "Aucune coordonnées de facturation.",
		"informations-address": "Adresse",
		"informations-email": "Email de réception",
		"informations-name": "Nom ou Entreprise"
	},
	"it": {
		"billing-details": "Informazioni di fatturazione",
		"billing-details-empty": "Nessun dato di fatturazione.",
		"informations-address": "Indirizzo",
		"informations-email": "Email di fatturazione",
		"informations-name": "Nome o Azienda"
	},
	"pt": {
		"billing-details": "Informações de faturação",
		"billing-details-empty": "Sem dados de faturação.",
		"informations-address": "Morada",
		"informations-email": "Email de faturação",
		"informations-name": "Nome ou Empresa"
	},
	"pl": {
		"billing-details": "Dane do faktury",
		"billing-details-empty": "Brak danych do faktury.",
		"informations-address": "Adres",
		"informations-email": "Email do faktury",
		"informations-name": "Imię lub Firma"
	}
}
</i18n>
